function getFileDataURL(file) {
    return new Promise((res) => {
        const fr = new FileReader();

        fr.onload = () => res(fr.result);
        fr.readAsDataURL(file);
    });
}

function initFileInput(container) {
    const input = container.querySelector("[type=file]");
    const img = container.querySelector("img");
    const placeholder = container.querySelector(".img-loader__placeholder");

    input.addEventListener("change", () => {
        const [ file ] = input.files;

        if (file) {
            getFileDataURL(file).then((src) => {
                container.classList.add("loaded");
                img.src = src;
                placeholder.textContent = file.name;
            });
        }
    });

    return {
        reset: () => {
            img.src = "";
            placeholder.textContent = placeholder.dataset.initial;
            container.classList.remove("loaded");
        }
    };
}

function init(container) {
    if (!container) {
        return;
    }

    const tabs = container.querySelector(".image-input__tabs");
    const tabsBorder = container.querySelector(".image-input__tabs-border");
    const content = container.querySelector(".image-input__content");

    function updateBorder(activeTab) {
        const { left, width } = activeTab.getBoundingClientRect();
        const { left: parentLeft } = tabs.getBoundingClientRect();
        const borderLeft = left - parentLeft;

        tabsBorder.style.width = width + "px";
        tabsBorder.style.left = borderLeft + "px";
    }

    function updateTabContent(activeTab) {
        const activeKey = activeTab.dataset.value;

        content.querySelectorAll(".image-input__block")
            .forEach(item => {
                item.classList.remove("active");
                item.querySelectorAll("input").forEach(i => i.disabled = true);
            });
        
        const activeBlock = content.querySelector(`.image-input__block[data-value="${ activeKey }"]`);

        activeBlock.classList.add("active");
        activeBlock.querySelectorAll("input").forEach(i => i.disabled = false);
    }

    function updateTabs(activeTab) {
        updateBorder(activeTab);
        updateTabContent(activeTab);

        container.querySelectorAll(".image-input__tabs-item.active")
            .forEach(item => item.classList.remove("active"));

        activeTab.classList.add("active");
    }

    tabs.addEventListener("click", (event) => {
        const item = event.target.closest(".image-input__tabs-item:not(.active)");

        if (item) {
            updateTabs(item);
        }
    });

    const fileInput = initFileInput(container.querySelector(".img-loader"));

    return {
        update: () => {
            updateTabs(container.querySelector(".image-input__tabs-item.active"));
        },
        reset: fileInput.reset
    }
}

export {
    init
};
